import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CancelIcon from '@mui/icons-material/Cancel';
import { Theme } from '@mui/material/styles';
import InfoIcon from '@/assets/icons/info.svg?react';
import HelpIcon from '@/assets/icons/help.svg?react';
import { STANDARD_TOOLTIP_ICON_SIZE } from '@/constants/unifiedSizes';

export const StyledIcons = styled.span`
  display: flex;
  align-items: center;
`;

export const StyledCopyIcon = styled(ContentCopyIcon)<{
  theme?: Theme;
  textColor?: string;
  width?: string;
  height?: string;
}>`
  width: ${({ width }) => (width ? width : '14px')};
  height: ${({ height }) => (height ? height : '14px')};
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.palette.customSecondary.neutral[100]};
  font-size: 14px;
  transition: 0.3s color;

  &:hover {
    color: ${({ theme }) => theme.palette.customSecondary.primary.hover};
  }
`;

export const StyledIconButton = styled(IconButton)`
  width: fit-content;
`;

export const StyledInfoIcon = styled(InfoIcon)<{
  theme?: Theme;
  width?: string;
  height?: string;
  color?: string;
}>`
  width: ${({ width }) => (width ? width : STANDARD_TOOLTIP_ICON_SIZE)};
  height: ${({ height }) => (height ? height : STANDARD_TOOLTIP_ICON_SIZE)};
  color: ${({ theme, color }) => (color ? color : theme.palette.customSecondary.neutral[300])};
  transition: color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
  }
`;

export const StyledHelpIcon = styled(HelpIcon)<{ theme?: Theme }>`
  width: ${STANDARD_TOOLTIP_ICON_SIZE};
  height: ${STANDARD_TOOLTIP_ICON_SIZE};
  color: ${({ theme, color }) => (color ? color : theme.palette.customSecondary.neutral[300])};

  transition: color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
  }
`;

export const StyledChipCancelIcon = styled(CancelIcon)<{ theme?: Theme }>`
  &.MuiChip-deleteIcon {
    color: ${({ theme }) => theme.palette.customSecondary.primary.DEFAULT};
    transition: color 0.3s;
  }

  &.MuiChip-deleteIcon:hover {
    color: ${({ theme }) => theme.palette.customSecondary.primary.hover};
  }

  // if wrapper has been used and SVG doesn't have MuiChip-deleteIcon class
  color: ${({ theme }) => theme.palette.customSecondary.primary.DEFAULT};
  transition: color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.primary.hover};
  }
`;
